module.exports = __webpack_public_path__ + "img/43.9e6664d8.png";